<template>
    <div>
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
            <a-form-item>
                <a-button type="primary" @click="getDataList" icon="reload">刷新</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="addOrUpdateHandle('', customer_id)" icon="plus">申请隐私通话</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id" :loading="dataListLoading"
            :scroll="{ x: 1200 }">
            <template slot="status" slot-scope="status, row">
                <a-tag :color="status === 1 ? 'green' : 'red'" v-if="row.status2 === 'approved'">{{ status === 1 ? '正常'
                    : '过期' }}</a-tag>
                <a-tag :color="row.status2 === 'processing' ? 'orange' : row.status2 === 'reject' ? 'red' : ''"
                    v-else>{{
                        row.status2
                            === 'processing' ? '审批中'
                            : row.status2 === 'reject' ? '审批拒绝' : '' }}</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-button type="link" class="p-5" @click="showCalllogModal(row.subsId)" v-permission="['admin:customer:showCalllogModal']">
                    查看通话记录
                </a-button>
            </template>
        </a-table>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <add-or-update ref="addOrUpdate" @ok="getDataList" />
        <!-- 通话记录 -->
        <!-- 弹窗显示通话记录 -->
        <!-- 关闭后销毁 -->
        <a-modal ref="calllogModal" title="通话记录" :visible.sync="calllogModalVisible" width="1000px"
            :destroy-on-close="true" @cancel="calllogModalVisible = false">
            <calllog :customer_id="customer_id" :subsId="subsId" />
            <template slot="footer">
                <a-button type="primary" @click="calllogModalVisible = false">关闭</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import AddOrUpdate from './AddOrUpdate.vue';
import calllog from '../TripProject/calllog.vue';
export default {
    mixins: [viewModule],
    components: {
        AddOrUpdate,
        calllog
    },
    props: {
        customer_id: String,
    },
    watch: {
        customer_id(newValue) {
            this.dataForm.customer_id = newValue
            this.getDataList()
        }
    },
    data() {
        return {
            subsId: "",
            calllogModalVisible: false,
            mixinViewModuleOptions: {
                getDataListURL: "/admin/trip/getSecretReport",
                deleteURL: "/admin/trip/deleteSecretReport", // You may need to implement this endpoint on the backend
            },
            dataForm: {
                customer_id: this.customer_id,
            },
            columns: [
                {
                    title: "主叫姓名",
                    dataIndex: "nick_name",
                    width: 140
                },
                {
                    title: "主叫手机号",
                    dataIndex: "phoneB",
                    width: 150,
                },
                {
                    title: "通话原因",
                    dataIndex: "reson",
                    width: 150,
                },
                {
                    title: "号码池",
                    dataIndex: "pool_key",
                    width: 180,
                },
                {
                    title: "虚拟号码",
                    dataIndex: "phoneNoX",
                    width: 150,
                    customRender: (text, row) => {
                        return row.status2 === "approved" ? text : "审批中"
                    }
                },
                {
                    title: "当前状态",
                    dataIndex: "status",
                    width: 150,
                    // customRender: (text) => text === 1 ? '正常' : '过期',
                    scopedSlots: { customRender: "status" },
                },
                {
                    title: "过期时间",
                    dataIndex: "expiration",
                    width: 180,
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: 180,
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 150,
                    fixed: 'right',
                },
            ],
        };
    },
    methods: {
        addOrUpdateHandle(id, customer_id) {
            this.$refs.addOrUpdate.init(id, customer_id);
        },
        showView(url) {
            this.$viewerApi({
                images: [url],
            });
        },
        showCalllogModal(subsId) {
            this.subsId = subsId;
            this.$nextTick(() => {
                this.calllogModalVisible = true;
            })
        },
    },
};
</script>

<style></style>